import { render } from "./OrderClassification.vue?vue&type=template&id=0d921314&scoped=true"
import script from "./OrderClassification.vue?vue&type=script&lang=js"
export * from "./OrderClassification.vue?vue&type=script&lang=js"

import "./OrderClassification.vue?vue&type=style&index=0&id=0d921314&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d921314"

export default script